import React from "react";

import { GraphListEditor } from "./GraphsInspector";

/**
 * LES SECTIONS QU'UN BILAN AJOUTE EN BAS DE PAGE (`content.metadata.extra_sections`).
 *
 * Un titre, une consigne facultative, et la même liste de graphes qu'une page
 * `score`. La fusion de `onPatchContent` s'arrête à `content` : `metadata` est
 * donc réécrit entier, avec ses autres réglages (`selected_metrics`…).
 */
export default function BoardSectionsInspector({ page, onPatchContent, ctx }) {
  const metadata = page.content?.metadata || {};
  const sections = Array.isArray(metadata.extra_sections) ? metadata.extra_sections : [];

  const patchSections = (next) => onPatchContent({
    metadata: { ...metadata, extra_sections: next },
  });
  const setSection = (index, fields) => patchSections(
    sections.map((section, i) => (i === index ? { ...section, ...fields } : section)),
  );

  return (
    <div style={{ marginTop: 20 }}>
      <div className="builder-section-header">
        <h3 className="builder-subsection-title">Sections ajoutées en bas de page ({sections.length})</h3>
        <button
          className="builder-btn-secondary"
          onClick={() => patchSections([...sections, { title: "", list_graph: [] }])}
        >+ Ajouter une section</button>
      </div>

      {sections.length === 0 && <div className="builder-empty">Aucune section ajoutée</div>}

      {sections.map((section, index) => (
        <div key={index} style={{ marginTop: 16 }}>
          <div className="builder-consequence-row">
            <input
              className="builder-input"
              aria-label={`Titre de la section ${index + 1}`}
              placeholder="Titre de la section (ex. Votre entreprise)"
              value={section.title || ""}
              onChange={(e) => setSection(index, { title: e.target.value })}
            />
            <button
              className="builder-icon-btn danger"
              title="Retirer cette section"
              onClick={() => patchSections(sections.filter((_, i) => i !== index))}
            >✕</button>
          </div>
          <input
            className="builder-input"
            aria-label={`Consigne de la section ${index + 1}`}
            placeholder="Consigne facultative, sous le titre"
            value={section.hint || ""}
            onChange={(e) => setSection(index, { hint: e.target.value })}
          />
          <GraphListEditor
            list={section.list_graph || []}
            onChange={(next) => setSection(index, { list_graph: next })}
            scoreDic={ctx?.scoreDic}
          />
        </div>
      ))}
    </div>
  );
}
